import styled from 'styled-components';

export const MetaverseLabSection = styled.section`
  padding: 5rem 0;
  background-color: var(--background-color);

  @media (max-width: 768px) {
    padding: 3rem 0;
  }
`;

export const SectionTitle = styled.h2`
  font-size: 2.5rem;
  color: var(--primary-color);
  text-align: center;
  margin-bottom: 1rem;
  font-weight: 700;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

export const SectionSubtitle = styled.p`
  font-size: 1.2rem;
  color: var(--text-color);
  text-align: center;
  max-width: 800px;
  margin: 0 auto 3rem;
  opacity: 0.8;

  @media (max-width: 768px) {
    font-size: 1rem;
    margin-bottom: 2rem;
  }
`;

export const LabContent = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3rem;
  align-items: center;

  @media (max-width: 992px) {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
`;

export const LabInfo = styled.div`
  @media (max-width: 992px) {
    order: 1;
  }
`;

export const LabDescription = styled.div`
  margin-bottom: 2rem;

  p {
    font-size: 1.1rem;
    line-height: 1.7;
    color: var(--text-color);
    margin-bottom: 1.5rem;
  }

  @media (max-width: 768px) {
    p {
      font-size: 1rem;
    }
  }
`;

export const LabFeatures = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
`;

export const FeatureItem = styled.div`
  background-color: var(--card-background);
  padding: 1.5rem;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  text-align: center;
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-5px);
  }

  svg {
    font-size: 2rem;
    color: var(--primary-color);
    margin-bottom: 1rem;
  }

  h4 {
    font-size: 1.2rem;
    color: var(--primary-color);
    margin-bottom: 0.5rem;
  }

  p {
    font-size: 0.9rem;
    color: var(--text-color);
    line-height: 1.5;
  }
`;

export const LabVisual = styled.div`
  .lab-image-placeholder {
    width: 100%;
    height: 400px;
    background-color: var(--primary-color);
    opacity: 0.8;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    overflow: hidden;

    &:after {
      content: 'Laboratório de Metaverso';
      position: absolute;
      color: rgba(255, 255, 255, 0.9);
      font-size: 1.2rem;
      font-weight: 500;
    }
  }

  @media (max-width: 992px) {
    order: 2;
    
    .lab-image-placeholder {
      height: 300px;
    }
  }
`;

export const Card = styled.div`
  background-color: var(--card-background);
  padding: 1.5rem;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  margin-bottom: 1.5rem;
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-5px);
  }
`;

export const CardIcon = styled.div`
  font-size: 2rem;
  color: var(--primary-color);
  margin-bottom: 1rem;
  
  svg {
    width: 40px;
    height: 40px;
  }
`;

export const CardTitle = styled.h4`
  font-size: 1.2rem;
  color: var(--primary-color);
  margin-bottom: 0.5rem;
  font-weight: 600;
`;

export const CardContent = styled.p`
  font-size: 0.9rem;
  color: var(--text-color);
  line-height: 1.5;
`;